<template>
  <v-row no-gutters>
    <v-col cols="auto" class="pa-4">
      <span v-html="infoContent" style="text-align: left"></span>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'InformationMap',
  data: () => ({
    rawHtml: '',
  }),
  computed: {
    infoContent: get('admin/settingsValues@info_module_content'),
  },
};
</script>

<style scoped lang="scss"></style>
